module.exports = __webpack_public_path__ + "static/media/ruler-vertical.01cb3655.svg";